<template>
  <div class="index-page container">
    <div class="billboard">
      <div class="wrapper">
        <div>
            <h1>Enabling the NDC Age for Travel Agencies</h1>
            <h2>Shop, Book and Service all your NDC content in one single platform</h2>

            <button
                class="btn btn-primary-outline large mr-3"
                @click="login()">
              Agency Login »
            </button>
            <router-link
                class="btn btn-primary-outline large"
                to="/register"
                role="button"
                v-if="isShowSignup"
            >
              Agency Registration »
            </router-link>
        </div>
      </div>
    </div>

    <div class="homeSectionContainer wrapper">
      <div class="homeProductsGrid">
        <div class="homeProductsItem">
          <div class="homeProductsItem__image">
            <img
                height="32"
                width="32"
                :src="require('@/assets/images/icon-desktop.svg')"
            />
          </div>
          <div class="homeProductsItem__text">
            <h2 class="">Agent Desktop</h2>
            <h5>
              Ready to start using bookingpad?
            </h5>
            <p>
              Please note that in order to use our NDC Agency Desktop Solution you must have an account created and
              all the agency's credentials set up to receive airlines results.
            </p>
            <div>
              <a
                  class="btn btn-primary"
                  @click="goToLogin()"
                  href="#"
                  role="button"
              >Log In to Bookingpad
              </a>
            </div>
          </div>
        </div>

        <div class="homeProductsItem">
          <div class="homeProductsItem__image">
            <img
                height="32"
                width="32"
                :src="require('@/assets/images/icon-api.svg')"
            />
          </div>
          <div class="homeProductsItem__text">
            <h2>API Developer Guide</h2>
            <p>
              Read our API developer guide to get a brief idea on what our
              API can provide.
            </p>
            <div>
              <a
                  class="btn btn-primary-outline"
                  href="https://dev-guides.airgateway.net/"
                  target="_blank"
                  role="button"
              >Read the Docs
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationBar from "./shared/+navigation-bar";
import helpers from "@/mixins/helpers";

export default {
  data() {
    return {
      activeAgents: -1,
      activeAgencies: -1,
      plan: '',
      airlines: [],
    }
  },
  mixins: [helpers],
  components: {
    NavigationBar
  },
  mounted: function () {
    if (this.$localStorage.get("logged")) {
      this.$router.push('/member/dashboard')
    }
  },
  computed: {
    isShowSignup() {
      return process.env.VUE_APP_SHOW_SIGNUP === 'true'
    },
  },
  methods: {
    isLogged() {
      return this.$localStorage.get("logged");
    },
    goToLogin() {
      const url = process.env.VUE_APP_BACKOFFICE_URL + `/login`;
      var win = window.open(url, '_blank');
      win.focus();
    }
  }
};
</script>

<style lang="scss">

</style>
